/**
 * 作品基础信息区域组件
 * @author wangyichen
 * @since 2018/09/16
 */
import './base-info.less';
import VARIABLES from 'constants/variable.json5';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
class BaseInfo extends Component {
  static propTypes = {
    baseInfo: PropTypes.object,
  };

  componentDidMount() {
    this.initStat(
      '访问作品详情页',
      'web_apppreview_detail_preview',
      Stat.ACTION_INIT
    );
  }

  initStat = (name, pointId, action) => {
    let others = {};
    const { baseInfo } = this.props;
    const { templateId, tplSpecies, tplFreeLimit, id } = baseInfo;
    if (templateId) {
      others = {
        type: tplSpecies,
        templateused: templateId ? '1' : '2',
        tplid: templateId,
        price: tplFreeLimit ? '1' : '2',
      };
    }
    sendStat('RP_STORE', '作品案例详情页', name, action, {
      id: pointId,
      app_id: id,
      ...others,
    });
  };

  sendStatClick = () => {
    this.initStat(
      '点击作品详情页中的制作按钮',
      'web_apppreview_detail_make_click',
      Stat.ACTION_CLICK
    );
  };

  render() {
    const { baseInfo } = this.props;
    const {
      appName,
      userName,
      desc,
      tags,
      templateId,
      tplSpecies,
      tplShelf,
    } = baseInfo;
    let tplType;
    switch (tplSpecies) {
      case 1: {
        tplType = VARIABLES.RP_H5;
        break;
      }
      case 2: {
        tplType = VARIABLES.RP_SPA;
        break;
      }
      case 3: {
        tplType = VARIABLES.RP_VIDEO;
        break;
      }
      case 4: {
        tplType = VARIABLES.RP_GAME;
        break;
      }
      default:
        tplType = VARIABLES.RP_H5;
    }
    const useSameTplSrc = `/template/multipage.html#${templateId}#${tplType}`;
    return (
      <div className="base-info">
        <h1>{appName ? appName : '该作品暂无标题'}</h1>
        <div style={{ marginBottom: '15px' }}>
          作者：
          <span>
            {userName
              ? userName.length > 30
                ? userName.slice(0, 30) + '...'
                : userName
              : '暂无'}
          </span>
        </div>
        <div style={{ marginBottom: '17px' }}>
          描述：
          <span>
            {desc
              ? desc.length > 30
                ? desc.slice(0, 30) + '...'
                : desc
              : '暂无'}
          </span>
        </div>
        {tags && tags.length ? (
          <div className="tag-wrap">
            标签：
            <div className="tag-bar">
              {tags.map(v =>
                v.tag ? (
                  <a
                    style={{
                      width: `${v.tag.length <= 3 ? '73px' : null}`,
                      padding: `${v.tag.length > 3 ? '0 15px' : null}`,
                    }}
                    key={v.id}
                    className="tag"
                    href={`/preview/search-${v.id}.html`}>
                    {v.tag}
                  </a>
                ) : null
              )}
            </div>
          </div>
        ) : null}
        {templateId && +tplShelf === 1 ? (
          <a
            href={useSameTplSrc}
            style={{ marginBottom: '8px' }}
            onClick={this.sendStatClick.bind(this)}>
            <button className="btn">使用相同模板制作</button>
          </a>
        ) : (
          <a
            href="/template/"
            target="_blank"
            style={{ marginBottom: '8px' }}
            onClick={this.sendStatClick.bind(this)}>
            <button className="btn">免费制作</button>
          </a>
        )}
      </div>
    );
  }
}

export default BaseInfo;
